import React, { PureComponent } from "react";
import { PieChart, Pie, Sector } from "recharts";
import { getFormatNumber } from "Utils";
import { STATUS, SIGN } from "Config";

export class PrincipalPieChart extends PureComponent {
  renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    payload
  }) => {
    const RADIAN = Math.PI / 180;
    const radius = outerRadius + innerRadius * 0.25;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill={
          payload.status === STATUS.ALERT
            ? "#FF5656"
            : payload.status === STATUS.WARNING
              ? "#FFB340"
              : "#18A0FB"
        }
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        {`${payload.sign === SIGN.NEGATIVE ? "-" : ""}${getFormatNumber(
          payload.value
        )}${this.props.metric} (${payload.code})`}
      </text>
    );
  };

  render() {
    return (
      <PieChart width={this.props.width} height={this.props.width}>
        <Pie
          data={this.props.data}
          innerRadius={116}
          outerRadius={132}
          label={this.renderCustomizedLabel}
          fill="#18A0FB"
          dataKey="value"
          paddingAngle={1}
        />
        <text x={213} y={238} dy={20} fontSize={24} fill="#18A0FB">
          {`${
            this.props.payload.sign === SIGN.NEGATIVE ? "-" : ""
          }${getFormatNumber(this.props.payload.value)}${this.props.metric}`}
        </text>
      </PieChart>
    );
  }
}

export class SecondaryPieChart extends PureComponent {
  renderActiveShape = props => {
    const {
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      payload
    } = props;

    return (
      <g>
        <text
          x={cx}
          y={cy}
          dy={8}
          textAnchor="middle"
          fill={
            payload.status === STATUS.ALERT
              ? "#FF5656"
              : payload.status === STATUS.WARNING
                ? "#FFB340"
                : payload.status === STATUS.GREAT
                  ? "#06D9B1"
                  : "#18A0FB"
          }
        >
          {`${payload.sign === SIGN.NEGATIVE ? "-" : ""}${getFormatNumber(
            payload.value
          )}${this.props.metric ? this.props.metric : ""}`}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={
            payload.status === STATUS.ALERT
              ? "#FF5656"
              : payload.status === STATUS.WARNING
                ? "#FFB340"
                : "#18A0FB"
          }
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={
            payload.status === STATUS.ALERT
              ? "#FF5656"
              : payload.status === STATUS.WARNING
                ? "#FFB340"
                : "#18A0FB"
          }
        />
      </g>
    );
  };

  render() {
    return (
      <PieChart width={300} height={200}>
        <Pie
          activeIndex={this.props.activeIndex}
          activeShape={this.renderActiveShape}
          data={this.props.data}
          innerRadius={60}
          outerRadius={72}
          fill="#C7E8FE"
          dataKey="value"
        />
      </PieChart>
    );
  }
}

export class TwoValuePieChart extends PureComponent {
  prepareData = () => {
    return this.props.item.value > this.props.item.total
      ? [this.props.item, { value: 0 }]
      : [
          this.props.item,
          { value: this.props.item.total - this.props.item.value }
        ];
  };

  renderActiveShape = props => {
    const {
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      payload
    } = props;

    return (
      <g>
        <text
          x={cx}
          y={cy}
          dy={8}
          textAnchor="middle"
          fontSize={this.props.width > 400 ? 24 : 16}
          fill={
            payload.status === STATUS.ALERT
              ? "#FF5656"
              : payload.status === STATUS.WARNING
                ? "#FFB340"
                : payload.status === STATUS.GREAT
                  ? "#06D9B1"
                  : "#18A0FB"
          }
        >
          {`${payload.sign === SIGN.NEGATIVE ? "-" : ""}${getFormatNumber(
            payload.value
          )}${this.props.metric}`}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={
            payload.status === STATUS.ALERT
              ? "#FF5656"
              : payload.status === STATUS.WARNING
                ? "#FFB340"
                : payload.status === STATUS.GREAT
                  ? "#06D9B1"
                  : "#18A0FB"
          }
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={
            payload.status === STATUS.ALERT
              ? "#FF5656"
              : payload.status === STATUS.WARNING
                ? "#FFB340"
                : payload.status === STATUS.GREAT
                  ? "#06D9B1"
                  : "#18A0FB"
          }
        />
      </g>
    );
  };
  render() {
    return (
      <PieChart width={this.props.width} height={this.props.height}>
        <Pie
          activeIndex={0}
          activeShape={this.renderActiveShape}
          data={this.prepareData()}
          innerRadius={this.props.innerRadius}
          outerRadius={this.props.outerRadius}
          fill="#C7E8FE"
          dataKey="value"
        />
      </PieChart>
    );
  }
}

export class SimplePieChart extends PureComponent {
  renderActiveShape = props => {
    const {
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      payload
    } = props;

    return (
      <g>
        <text x={cx} y={cy} dy={4} textAnchor="middle" fill={"#18A0FB"}>
          {parseInt(payload.percentage, 10) + "%"}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={"#18A0FB"}
        />
      </g>
    );
  };

  render() {
    return (
      <PieChart width={this.props.width} height={this.props.width}>
        <Pie
          activeIndex={this.props.activeIndex}
          activeShape={this.renderActiveShape}
          data={this.props.data}
          innerRadius={this.props.scaled ? 100 : 40}
          outerRadius={this.props.scaled ? 122 : 45}
          fill="#C7E8FE"
          dataKey="value"
        />
      </PieChart>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Charts/PieChart.js